// extracted by mini-css-extract-plugin
export default {"loadingBox":"id_loadingBox__M+BUr","classTit":"id_classTit__bep0q","loader":"id_loader__uecEM","l13":"id_l13__FUqZa"};